/* eslint-disable */
import React from "react";
import Skeleton from "@mui/material/Skeleton";
import * as Styles from "./sharedLeadSkeleton.styles";

export const SharedLeadSkeleton: React.FC = () => {
  return (
    <Styles.Container>
      <Styles.RowSpace>
        <Skeleton variant="rectangular" width={250} height={30} />
        <Skeleton variant="rectangular" width={250} height={30} />
      </Styles.RowSpace>
      <Skeleton
        variant="rounded"
        width="100%"
        height={90}
        style={{ marginTop: 8 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={140}
        style={{ marginTop: 8 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={90}
        style={{ marginTop: 8 }}
      />
      <Styles.RowSpaceMT>
        <Skeleton variant="rectangular" width={200} height={30} />
        <Skeleton variant="rectangular" width={200} height={30} />
      </Styles.RowSpaceMT>
    </Styles.Container>
  );
};
